import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { organizationConsentModeApi } from '../api/client';

/**
 * ログイン中の本人の録音で、文字起こし（音声認識）を行うか（課題 #99 / BE PR #153）。
 *
 * 2026-10-01 高尾さん決定: 文字起こしは、centric で同意を取り直した方だけ行い、ほかの組織では行わない。
 * 設定が欠けたとき・読めないときも「行う」に戻さないため、BE が true を返したときだけ true にする
 * （読み込み中・失敗・項目が無い BE はすべて false）。
 */
export function useTranscriptionEnabled(): boolean {
  const { getToken } = useAuth();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const token = getToken();
    if (!token) return;
    let cancelled = false;
    organizationConsentModeApi
      .getSelf(token)
      .then((res) => {
        if (!cancelled) setEnabled(res?.transcription_enabled === true);
      })
      .catch(() => {
        if (!cancelled) setEnabled(false);
      });
    return () => {
      cancelled = true;
    };
  }, [getToken]);

  return enabled;
}
